var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavdownarrow10Px12Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20556,
    width: 5.51969,
    height: 5.51969,
    transform: "matrix(0.602782 -0.797906 0.602782 0.797906 1.07436 6.96193)",
    fill: "white",
    strokeWidth: 2,
    stroke: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8.495,
    y: 1.057,
    width: 1.114,
    height: 1.886,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.657,
    y: -0.257,
    width: 10.667,
    height: 6.248,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavdownarrow10Px12Px);
export default __webpack_public_path__ + "static/media/navdownarrow-10px-12px.9cb5094625be42db90ab8581848417c1.svg";
export { ForwardRef as ReactComponent };